import triggerTracking from '@blueprint/tracking';
import { trackSegmentAndGAEvent } from '@zoopla/tracking';

export const trackAllPropertyNewsCTA = () => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'homepage',
        eventAction: 'clickthrough',
        eventLabel: 'all_property_news'
    });
};

export const trackIndividualArticle =
    (category: string, slug: string, index: number) => () => {
        triggerTracking({
            event: 'GAEvent',
            eventCategory: 'content_module',
            eventAction: 'article_clickthrough',
            eventLabel: `/discover/${category}/${slug}/,${index}`
        });
    };

export const trackPersonalisedBannerShown = (eventLabel: string) =>
    trackSegmentAndGAEvent(
        'Module Shown',
        {
            eventCategory: 'personalised_cta',
            eventLabel,
            eventAction: 'module_shown'
        },
        '/homepage/'
    );

export const trackPersonalisedBannerClicked = (eventLabel: string) =>
    trackSegmentAndGAEvent(
        'Module Interaction',
        {
            eventCategory: 'personalised_cta',
            eventLabel,
            eventAction: 'clickthrough'
        },
        '/homepage/'
    );
